import React from "react";
import {
  Select,
  Label,
  Checkbox,
  makeStyles,
} from "@fluentui/react-components";
import { CoverageComponentProps } from "./types";

const useStyles = makeStyles({
  rightAlignedInput: {
    "& input": {
      textAlign: "right",
    },
  },
});

const AssistanceCoverage: React.FC<CoverageComponentProps<"assistance">> = ({
  config,
  onConfigChange,
  t,
  classes,
}) => {
  const styles = useStyles();

  return (
    <>
      <div
        style={{
          display: "flex",
          gap: "16px",
          alignItems: "flex-end",
          justifyContent: "flex-start",
          marginBottom: "16px",
        }}
      >
        <div
          className={classes.fieldGroup}
          style={{ flex: "0 0 calc(50% - 8px)" }}
        >
          <Label htmlFor="assistanceRate" required>
            Rate
          </Label>
          <Select
            id="assistanceRate"
            value={config.rate || "4110"}
            onChange={(_, data) =>
              onConfigChange({
                rate: data.value,
              })
            }
          >
            <option value="4110">BASIC</option>
            <option value="4120">IDEAL</option>
            <option value="4130">MAX</option>
            <option value="4140">IDEAL KoopSalon</option>
            <option value="4150">MAX KoopSalon</option>
            <option value="4160">MAX+</option>
            <option value="4173">Small vehicles</option>
          </Select>
        </div>
        <div style={{ flex: "0 0 calc(50% - 8px)" }}></div>
      </div>

      <div style={{ marginTop: "8px" }}>
        <Checkbox
          label="Extension to any towed vehicle"
          checked={config.extensionToTowedVehicle || false}
          onChange={(_, data) => {
            onConfigChange({
              extensionToTowedVehicle: data.checked === true,
            });
          }}
        />
      </div>
    </>
  );
};

export default AssistanceCoverage;
